<template>
  <div class="projectCard" ref="card" id="card">
    <img :class="windowWidth < 650 ? 'column' : 'full'" v-if="project.images" :src="'/companies/' + project.images[0]" />
    <section class="projectInformation" :class="[windowWidth < 650 ? 'column' : 'full', !project.images ? 'fullWidth' : '']">
      <section class="appName">
        <h1 v-if="project.name">{{project.name}}</h1>
        <p>{{project.description}}</p>
      </section>
      <section class="myRole">
        <h1>{{$t("work.role")}}</h1>
        <p>{{project.myRole}}</p>
      </section>
      <section class="technologies">
        <h1>{{$t("work.techsUsed")}}</h1>
        <p>{{getTechnologiesUsed()}}</p>
      </section>
    </section>
  </div>
</template>

<script>
export default {
  props: [
    'project'
  ],
  data() {
    return {
      width: 0
    }
  },
  computed: {
    windowWidth() {
      return this.width
    }
  },
  methods: {
    getWindowWidth(event) {
        this.width = document.documentElement.clientWidth;
      },
    getTechnologiesUsed() {
      return this.project.technologies.join(", ").toString()
    }
  },
  mounted() {
    this.$nextTick(function() {
      window.addEventListener('resize', this.getWindowWidth);

      //Init
      this.getWindowWidth()
    })
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.getWindowWidth);
  }
};
</script>


<style scoped>
img.full {
  display: inline-bloc;
  width: 55%;
  min-width: 315px;
  margin-right: 1rem;
  vertical-align: top;
}
img.column {
  max-width: 320px;
  width: 90%;
  display: block;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 2rem;
}
.projectInformation.full {
  display: inline-block;
  width: 40%;
}
.projectInformation.column {
  display: block;
}
.projectInformation.fullWidth {
  width: 100%;
}
</style>


